import { useRef, useEffect } from 'react'
import env from '../env'

export const types = {
  standard: 'track',
}

const LINKEDIN_EVENT_SPECIFIC_CONVERSION_ID = env.LINKEDIN_EVENT_SPECIFIC_CONVERSION_ID

export default function useLinkedInEventTracker() {
  const ref = useRef()

  useEffect(() => {
    ref.current = window.lintrk
  }, [])

  return {
    event(params = {}) {
      if (!ref.current) {
        return null
      } else {
        return ref.current(types.standard, {
            conversion_id: LINKEDIN_EVENT_SPECIFIC_CONVERSION_ID,
            ...params
        })
      }
    }
  }
}
